import styled from 'styled-components';

import { CustomCss } from '@utils/types';
export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
`;
export const CheckboxContainerSapData = styled.div`
  display: flex;
  align-items: start;
  cursor: pointer;
  position: relative;
  top: 45px;
`;
export const SegmentContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  gap: 5px;
  width: 100%;
`;

// Hide checkbox visually but remain accessible to screen readers.
// Source: https://polished.js.org/docs/#hidevisually
export const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
  height: 1px;
`;

type LabelProps = {
  customCss?: CustomCss;
};
export const Label = styled.span<LabelProps>`
  ${(props) => props.customCss}
  flex: 1;
  padding: 0 5px;
  display: inline-flex;
`;

type SegmentLabelProps = {
  customCss?: CustomCss;
};
export const SegLabel = styled.span<SegmentLabelProps>`
  padding: 0 5px;
  ${(props) => props.customCss}
  width: 100%;
`;

export const CheckBoxSubTitle = styled.span`
  opacity: 0.6;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;
